export default __webpack_public_path__ + "static/media/music-qzuki.7cdae07e.png";